import { useState, useCallback } from 'react';
import { useDataAuth } from './useDataAuth';
import { callApi } from '../services/api.service';
import { ensureArray } from '../utils/validateResponseApi';

export const useCompanies = (handleSetCompany,) => {
    const [{ userSession }] = useDataAuth();
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchCompanies = useCallback(async (id_user_action) => {
        if (!id_user_action || !userSession?.token) return [];

        setLoading(true);
        setError(null);

        try {
            const response = await callApi("company_select", "SELECT_COMPANIES_BY_USER_ACTION_ID", { id_user_action }, userSession.token);
            console.log('response.status === 200', response.status === 200);
            if (response.status === 200 && response?.data) {
                const companies = ensureArray(response.data);
                setCompanies(companies);
                return companies;
            }
            setCompanies([]);
            return [];
        } catch (err) {
            setError(err.message);
            setCompanies([]);
            return [];
        } finally {
            setLoading(false);
        }
    }, [userSession?.token]);

    const clearCompanies = useCallback(() => {
        setCompanies([]);
        setError(null);
    }, []);

    return {
        companies,
        loading,
        error,
        fetchCompanies,
        clearCompanies
    };
};

export default useCompanies;